import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/services/config.service';
import { StringService } from 'src/app/services/string.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  public title = 'Message';
  public description = 'Are you sure you want to confirm the appointment?<br><br>';
  public confirmText = 'Confirm';
  public textAreaHint = 'Comment';
  public textAreaValue = '';
  public showConfirm = true;
  public hideClose = false;
  public IAgree = false;
  public showTickAgree = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    public stringService: StringService,
    public toastr: ToastrService,
    public configService: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    if (this.data != null) {
      if (this.stringService.isNotEmpty(this.data.title)) {
        this.title = this.data.title;
      }

      if (this.stringService.isNotEmpty(this.data.description)) {
        this.description = this.data.description;
      }

      if (this.stringService.isNotEmpty(this.data.confirmText)) {
        this.confirmText = this.data.confirmText;
      }

      if (this.stringService.isNotEmpty(this.data.textAreaHint)) {
        this.textAreaHint = this.data.textAreaHint;
      }

      if (this.stringService.isNotEmpty(this.data.textAreaValue)) {
        this.textAreaValue = this.data.textAreaValue;
      }

      if (this.stringService.isNotEmpty(this.data.showConfirm)) {
        this.showConfirm = this.data.showConfirm;
      }

      if (this.stringService.isNotEmpty(this.data.hideClose)) {
        this.hideClose = this.data.hideClose;
      }

      if (this.stringService.isNotEmpty(this.data.showTickAgree)) {
        this.showTickAgree = this.data.showTickAgree;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.IAgree == false) {
      this.showErrorMessage(this.configService.config.loginAgreeCheckBoxNotTickMesssage);
      return;
    }
    this.data.action = 1;
    this.dialogRef.close(this.data);
  }

  showErrorMessage(message: string): void {
    this.toastr.error(message, 'Error', { timeOut: 3000 });
  }

}
